<div class="row-item">
  <div class="left">
    <div tabindex="0" class="status" [attr.aria-label]="'Learning Object Status: ' + learningObject.status + '. ' + statusDescription" [ngClass]="learningObject.status" [tip]="statusDescription" [tipDisabled]="!statusDescription" tipPosition="top">
      <span *ngIf="learningObject.status === 'unreleased'"><i class="fas fa-eye-slash"></i></span>
      <span *ngIf="learningObject.status === 'waiting'"><i class="fas fa-hourglass"></i></span>
      <span *ngIf="learningObject.status === 'review'"><i class="fas fa-sync"></i></span>
      <span *ngIf="learningObject.status === 'proofing'"><i class="fas fa-shield"></i></span>
      <span *ngIf="learningObject.status === 'released'"><i class="fas fa-eye"></i></span>
      <span *ngIf="learningObject.status === 'rejected'"><i class="fas fa-ban"></i></span>
      <span *ngIf="learningObject.status === 'accepted_minor'"><i class="fas fa-check-double"></i></span>
      <span *ngIf="learningObject.status === 'accepted_major'"><i class="fas fa-check"></i></span>
    </div>
    <div>
      {{ (learningObject.name.length > 40) ? (learningObject.name | slice:0:40) + '...' : learningObject.name }}
    </div>
  </div>
  <div class="right">
        <div>{{ learningObject.length | titlecase }}</div>
        <div>{{ (learningObject.assigned) ? learningObject.assigned.length : 0 | titlecase }} Evaluator<span *ngIf="learningObject.assigned && learningObject.assigned.length !== 1">s</span></div>
  </div>
</div>